
 import axios from "axios";
import { APIAdapter } from "../../../../helpers/api_helper";
 const api = new APIAdapter();
 export const getAverageMonthlyVolume= async () => {
      try {
        const response = await api.get(`/admin/dashboard/stats`);
        return response;
      } catch (error) {
        throw error;
      }
  };
export const transactionsStatsMonthYear = async (month, year) => {
  try {
    const response = await api.get("/admin/dashboard/transactions-stats", {
        month,
        year
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const transactionsStatsMonthYearMerchant = async (month, year,merchantId) => {
  try {
    const response = await api.get("/admin/dashboard/transactions-stats/merchant", {
        month,
        year,
        merchantId
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const revenusYear = async ( year) => {
  try {
    const response = await api.get("/admin/dashboard/monthly-revenue", {
        year
    });
    return response;
  } catch (error) {
    throw error;
  }
};
  
   export const getAllDevelopers = async () => {
      try {
        const response = await api.get(`/developer-accounts/all`)        
        return response;
      } catch (error) {
        throw error;
      }
  };
    export const getManagePayIn = async () => {
      try {
         const response = await axios.get(`${process.env.REACT_APP_API_TRANSACTION}/manage/pay-in`);       
        return response;
      } catch (error) {
        throw error;
      }
  };
   
export const getTransactionByMarchand = async (merchant) => {
  try {
    const token = JSON.parse(sessionStorage.getItem("authAdmin"))?.token;

    const response = await axios.get(
      `${process.env.REACT_APP_API_TRANSACTION}/manage/pay-in/merchant`,
      {
        params: {
          merchant: merchant,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("🔴 API ERROR:", error?.response?.data || error);
    throw error;
  }
};
   
export const getStatsByMerchantId = async (merchantId) => {
  const response = await api.get(`/admin/dashboard/stats/merchant/${merchantId}`);
  return response;
};
export const revenusYearByMerchant = async (merchantId, year) => {
  const response = await api.get(`/admin/dashboard/monthly-revenue/merchant/${merchantId}`, {
     year
  });
    console.log("merchents",response)
  return response;
};
  export const getRevenuAllMerchent = async () => {
      try {
        const response = await api.get(`/admin/dashboard/merchants/total-revenue`);
        return response;
      } catch (error) {
        throw error;
      }
  };
   export const PaxityInfo = async () => {
      try {
         const response = await axios.get(`${process.env.REACT_APP_API_TRANSACTION}/paxity-info`);
        return response;
      } catch (error) {
        throw error;
      }
  };
    export const getRevenuByCountry = async (country) => {
      try {
        const response = await api.get(`/commissions/${country}`);
        return response;
      } catch (error) {
        throw error;
      }
  }

   
   